import { CheckboxIcon, CheckboxIndicator } from '@vidahealth/vida-ui';
import { Check } from 'lucide-react-native';

/**
 * The checkbox tick — vida-ui's `CheckboxIndicator` + check glyph with the
 * dark-mode color override baked in. vida-ui's default `CheckboxIcon` color
 * (`text-typography-50`) resolves to `#f5f5f5` in light (fine on the
 * primary-600 fill) but `#262627` in dark, which is unreadable on that same
 * blue fill — so we force white in dark. Use this instead of repeating
 * `<CheckboxIndicator><CheckboxIcon as={Check} className='dark:text-typography-white' /></CheckboxIndicator>`
 * at every checkbox.
 */
export function CheckboxCheckIndicator() {
  return (
    <CheckboxIndicator>
      <CheckboxIcon as={Check} className='dark:text-typography-white' />
    </CheckboxIndicator>
  );
}
